"use client"
import Box from "@mui/material/Box"
import { NextImage } from "@src/components"


const Banner = ({ sx = {}, name, imgSrc }) => {
  return (
    <NextImage
      src={imgSrc || "/assets/images/no-image.png"}
      alt={name || "Banner"}
      loading="lazy"
      sizes="100vw"
      sx={{
        width: "100%",
        borderRadius: "24px",
        overflow: "hidden",
        aspectRatio: {
          xs: "16/9",
          md: "21/9"
        },
        "& .next-image-full": {
          objectFit: "cover"
        },
        ...sx
      }}
    />
  )
}

export default Banner
